/* fw-collection: filters, sort and pages on the collection and search pages.
   The toolbar is a plain GET form that works with no script. This file submits it on every
   change and swaps in the new results through the Section Rendering API (?section_id=), so
   the page does not reload. Listeners sit on the outer [data-fwc] node, which is never
   replaced, so they survive every swap. */
(function () {
  var root = document.querySelector('[data-fwc]');
  if (!root || !window.fetch || !window.DOMParser) return;
  var section = root.getAttribute('data-section');
  var mobile = window.matchMedia('(max-width: 759px)');
  var ctrl = null;
  var timer = null;

  function form() { return root.querySelector('[data-fwc-form]'); }
  function bar() { return root.querySelector('.fwc-bar'); }

  function formUrl() {
    var f = form();
    var params = new URLSearchParams();
    var sort = f.querySelector('[data-fwc-sort]');
    var dflt = sort ? sort.getAttribute('data-default') : '';
    new FormData(f).forEach(function (v, k) {
      if (String(v).trim() === '') return;
      if (k === 'sort_by' && v === dflt) return;
      params.append(k, v);
    });
    var q = params.toString();
    return f.getAttribute('action') + (q ? '?' + q : '');
  }

  function openGroups() {
    return Array.prototype.map.call(root.querySelectorAll('.fwc-group[open]'), function (d) {
      return d.getAttribute('data-fwc-group');
    });
  }

  function load(url, opts) {
    opts = opts || {};
    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var keepOpen = openGroups();
    var sheetOpen = bar() && bar().classList.contains('open');
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', section);
    root.classList.add('busy');
    return fetch(u.toString(), { signal: ctrl ? ctrl.signal : undefined, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-fwc-results]');
        if (!fresh) throw new Error('no results node');
        root.querySelector('[data-fwc-results]').innerHTML = fresh.innerHTML;
        if (opts.keepUi !== false) {
          keepOpen.forEach(function (g) {
            var d = root.querySelector('.fwc-group[data-fwc-group="' + g + '"]');
            if (d) d.open = true;
          });
          if (sheetOpen && bar()) setSheet(true, true);
        }
        if (opts.push !== false) history.pushState({ fwc: 1 }, '', url);
        if (opts.scroll) {
          var top = root.querySelector('.fwc-bar') || root;
          var y = top.getBoundingClientRect().top + window.pageYOffset - 110;
          if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
        }
      })
      .catch(function (e) { if (e && e.name !== 'AbortError') location.href = url; })
      .then(function () { root.classList.remove('busy'); });
  }

  function setSheet(on, instant) {
    var b = bar();
    if (!b) return;
    b.classList.toggle('open', on);
    var btn = b.querySelector('[data-fwc-open]');
    if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    document.documentElement.style.overflow = on && mobile.matches ? 'hidden' : '';
    if (on && !instant) {
      var close = b.querySelector('[data-fwc-close]');
      if (close) close.focus({ preventScroll: true });
    }
  }

  root.addEventListener('change', function (e) {
    if (!e.target.closest('[data-fwc-form]')) return;
    clearTimeout(timer);
    var isPrice = e.target.type === 'number';
    timer = setTimeout(function () { load(formUrl(), { scroll: !mobile.matches }); }, isPrice ? 350 : 60);
  });

  root.addEventListener('submit', function (e) {
    if (!e.target.closest('[data-fwc-form]')) return;
    e.preventDefault();
    var wasOpen = bar() && bar().classList.contains('open');
    if (wasOpen) setSheet(false);
    load(formUrl(), { scroll: true, keepUi: false });
  });

  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-fwc-link]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault();
      var inPages = !!a.closest('.fwc-pages');
      load(a.href, { scroll: true, keepUi: !inPages });
      return;
    }
    if (e.target.closest('[data-fwc-open]')) { setSheet(true); return; }
    if (e.target.closest('[data-fwc-close]')) { setSheet(false); return; }
  });

  // one popover at a time on desktop
  root.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('fwc-group') || !d.open || mobile.matches) return;
    root.querySelectorAll('.fwc-group[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  // close popovers on an outside click, the sheet on its backdrop
  document.addEventListener('click', function (e) {
    var b = bar();
    if (b && b.classList.contains('open') && mobile.matches && !e.target.closest('.fwc-sheet') && !e.target.closest('[data-fwc-open]')) {
      setSheet(false);
    }
    if (!mobile.matches && !e.target.closest('.fwc-group')) {
      root.querySelectorAll('.fwc-group[open]').forEach(function (o) { o.open = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var b = bar();
    if (b && b.classList.contains('open')) { setSheet(false); var o = b.querySelector('[data-fwc-open]'); if (o) o.focus(); return; }
    var d = root.querySelector('.fwc-group[open]');
    if (d) { d.open = false; d.querySelector('summary').focus(); }
  });

  window.addEventListener('popstate', function () { load(location.href, { push: false, keepUi: false }); });
  mobile.addEventListener && mobile.addEventListener('change', function () { setSheet(false); });
})();
